// extracted by mini-css-extract-plugin
export default {"container":"style_container__tuxPw","icon":"style_icon__4dvHG"};